module.exports = __webpack_public_path__ + "img/dhl-logo.48075434.png";